import realpressBecomeAgent from './shortcode/become-an-agent/submit';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressBecomeAgent();
} );
